import { Getters } from 'vuex-smart-module';
import { SelectItem } from '@/types';
import CartState from './state';

export default class CartHistoryGetters extends Getters<CartState> {
  get organizations_select(): SelectItem[] {
    return Object.keys(this.state.organizations).map((org_name) => ({
      text: org_name,
      value: this.state.organizations[org_name],
    }));
  }
}
